import Vue from 'vue';
import App from './App.vue';
import vhtml from 'vhtml-ui';
import router from '../../router/history';
import request from '../../utils/ajax';
import { PromiseHelperAllSettled } from '../../utils/Promise';
import filterMenuPage from './config';
import robotMenuHandle from '../../cgi/zhiku/api/menuHandler';
import { isSsc } from '../../cgi/zhiku/api/tools';
if (Promise && !Promise.allSettled) {
  Promise.allSettled = PromiseHelperAllSettled;
}

Vue.config.productionTip = false;
Vue.prototype.$ajax = request;
Vue.config.devtools = true;
import { pageDataStore } from '@/components/page-data';

Vue.use(vhtml);
if (window.QD_ADMIN_COMMON) {
  window.QD_ADMIN_COMMON.init({
    useNewMenu: true,
    skeletonId: 'app',
    menu: {
      menuClick: (e, v) => {
        console.log('[菜单]', v, router);
        // 匹配到路由使用
        if (router.matcher.match(v.originUrl).matched.length) {
          e.preventDefault();
          router.push(v.originUrl);
        }
      },
      menuListDataHandle: isSsc && filterMenuPage.includes(window.location.pathname) ? robotMenuHandle : undefined,
    },
  });
  QD_ADMIN_COMMON.on('dataReady', () => {
    pageDataStore.state.commonDataReady = true;
  });
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
